module.exports = __webpack_public_path__ + "static/media/EasyCall-logo.2c6de167.svg";